// extracted by mini-css-extract-plugin
var _1 = "nsi6APG8DkqRD6Y2Kovp";
export { _1 as "consequencesTd" }
